import * as React from 'react';
import Head from 'next/head';
import { AppCacheProvider } from '@mui/material-nextjs/v13-pagesRouter';
import { initializeAPM } from '@raisin/fe-apm';
import packageData from '../../package.json';
// importing the styles otherwise they will not be applied to components imported from cp-legacy-ui-lib
import '@raisin/cp-legacy-ui-lib/lib/styles.css';
import 'swiper/swiper-bundle.min.css';
import { type RaisinAppProps } from '@raisin/cp-layout';
import { getFaviconFromPageProps } from '@raisin/cp-utils';

initializeAPM({ zoneName: 'customer-portal', version: packageData.version });

export default function App(props: RaisinAppProps) {
  const { Component, pageProps } = props;
  const favicon = getFaviconFromPageProps(pageProps, '/cp_assets/favicon.ico');

  return (
    <AppCacheProvider {...props}>
      <Head>
        <link rel="icon" href={favicon} />
      </Head>

      <Component {...pageProps} />
    </AppCacheProvider>
  );
}
